import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-lg-row-fluid me-5 order-2 order-lg-1 mb-10 mb-lg-0" }
const _hoisted_3 = { class: "d-flex flex-wrap" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "مجموع خرید زیرمجموعه ها :", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 pe-1" }, "تومان", -1)
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "مجموع پورسانت :", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 pe-1" }, "تومان", -1)
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "تعداد زیر مجموعه ها :", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 pe-1" }, "نفر", -1)
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "تعداد خرید زیرمجموعه ها :", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 pe-1" }, "عدد", -1)
const _hoisted_16 = { class: "flex-column flex-lg-row-auto w-lg-250px w-xl-300px mb-10 order-1 order-lg-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary rounded w-100",
    id: "kt_user_follow_button",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_tutorial_modal"
  }, "آموزش پنل نمایندگی")
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "برای شروع همکاری و پیوستن به جمع نمایندگان فروش ما، قوانین را مطالعه و درخواست خود را ثبت کنید", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, "ضوابط اخذ نمایندگی فروش اینباکسینو", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "تعهد به معرفی صحیح محصولات :"),
  /*#__PURE__*/_createTextVNode(" نمایندگان موظف‌اند محصولات را دقیق معرفی کرده و اطلاعات صحیح را به مشتریان منتقل کنند. ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "رعایت هویت و اعتبار برند :"),
  /*#__PURE__*/_createTextVNode(" هرگونه سوءاستفاده از نام، لوگو یا برند اینباکسینو ممنوع بوده و نمایندگان ملزم به حفظ هویت برند هستند. ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "عدم همکاری با رقبا :"),
  /*#__PURE__*/_createTextVNode(" همکاری با برندهای رقیب در طول فعالیت با اینباکسینو مجاز نیست. ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "کد تخفیف اختصاصی نمایندگان :"),
  /*#__PURE__*/_createTextVNode(" هر نماینده یک کد تخفیف اختصاصی دریافت می‌کند که می‌تواند از آن به‌عنوان ابزاری موثر برای جذب و تشویق مشتریان به خرید استفاده کند. ")
], -1)
const _hoisted_25 = { class: "col-12 mt-10" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "قوانین مربوط به پرداخت پورسانت", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " 1- شرایط دریافت پورسانت : "),
  /*#__PURE__*/_createElementVNode("div", null, "مبلغ پورسانت شما در پنل کاربری قابل مشاهده است."),
  /*#__PURE__*/_createElementVNode("div", null, "به ازای هر خریدی که توسط زیرمجموعه‌های شما انجام شود، پورسانت مربوط به آن خرید به شما تعلق می‌گیرد، به‌طوری‌که مبلغ پورسانت بر اساس هر خرید توسط زیرمجموعه‌ها محاسبه خواهد شد."),
  /*#__PURE__*/_createElementVNode("div", null, "فعال‌سازی پرداخت اولین پورسانت تنها در صورتی انجام خواهد شد که نماینده حداقل 5 زیرمجموعه فعال داشته باشد که خرید موفق انجام داده باشند."),
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("div", null, "حداقل مبلغ قابل برداشت :"),
    /*#__PURE__*/_createElementVNode("div", null, " برداشت پورسانت تنها در صورتی امکان‌پذیر است که مانده حساب نماینده به 1,000,000 تومان یا بیشتر برسد. مبالغ کمتر از این میزان قابل پرداخت نخواهند بود. "),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "درصد پورسانت بر اساس میزان فروش ماهانه :")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
      /*#__PURE__*/_createElementVNode("div", null, "تا 50 میلیون تومان: 5%"),
      /*#__PURE__*/_createElementVNode("div", null, "از 50+ تا 100 میلیون تومان: 10%"),
      /*#__PURE__*/_createElementVNode("div", null, "از 100+ تا 200 میلیون تومان: 15%"),
      /*#__PURE__*/_createElementVNode("div", null, "200+ میلیون تومان: 20%")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, "مثال : در صورت فروش 250 میلیون تومان و با احتساب پورسانت 20%، مبلغ 50 میلیون تومان به عنوان پورسانت در نظر گرفته می‌شود.")
  ])
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "2- محرمانگی اطلاعات"),
  /*#__PURE__*/_createElementVNode("div", null, "نمایندگان موظف به حفظ محرمانگی اطلاعات مشتریان و عدم انتقال این اطلاعات به اشخاص ثالث هستند.")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "3- حداقل فروش ماهانه"),
  /*#__PURE__*/_createElementVNode("div", null, " در راستای حفظ کیفیت همکاری و ارتقاء سطح خدمات به مشتریان، نمایندگان محترم موظف به ثبت حداقل 50 فروش موفق در هر ماه هستند. در صورت عدم دستیابی به این هدف: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "بررسی عملکرد: عملکرد نماینده توسط تیم ارزیابی مورد بررسی قرار خواهد گرفت."),
    /*#__PURE__*/_createElementVNode("li", null, "ارائه راهکار: در صورت نیاز، پیشنهادهایی برای بهبود عملکرد ارائه می‌شود."),
    /*#__PURE__*/_createElementVNode("li", null, "بازنگری شرایط همکاری: در صورت تکرار و عدم بهبود عملکرد، ادامه همکاری مورد بازنگری قرار خواهد گرفت که ممکن است منجر به قطع همکاری شود.")
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "4- پشتیبانی نمایندگان"),
  /*#__PURE__*/_createElementVNode("div", null, "نمایندگان در صورت نیاز به راهنمایی یا رفع مشکلات می‌توانند از طریق بخش پشتیبانی پنل خود اقدام نمایند.")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "5- شرایط فسخ همکاری"),
  /*#__PURE__*/_createElementVNode("div", null, "هرگونه تخلف شامل ارائه اطلاعات نادرست، جذب زیرمجموعه‌های غیرواقعی یا هر گونه سوءاستفاده از سیستم پورسانت‌دهی ممکن است منجر به قطع همکاری و لغو پورسانت‌ها شود.")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, null, -1)
const _hoisted_33 = { class: "form-check form-check-custom form-check-success form-check-solid ms-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray-600 me-2" }, "موافقم", -1)
const _hoisted_35 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/_createTextVNode("بازگشت")
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h3", null, "درخواست شما درحال بررسی است.", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "نتیجه درخواست شما از طریق پیامک به شما اطلاع داده خواهد شد.", -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("بازگشت")
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h3", null, "درخواست شما رد شده است.", -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("بازگشت")
const _hoisted_45 = { class: "d-flex flex-column fv-row" }
const _hoisted_46 = { class: "d-flex flex-wrap" }
const _hoisted_47 = { class: "col-md-12 fv-row mb-3 pe-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "fs-8 text-gray-700 mb-2 required" }, "وضعیت خود را انتخاب کنید.", -1)
const _hoisted_49 = { class: "mt-2" }
const _hoisted_50 = { class: "me-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8" }, "حقوقی", -1)
const _hoisted_52 = { class: "me-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8" }, "حقیقی", -1)
const _hoisted_54 = { class: "col-md-4 fv-row mb-3 pe-1" }
const _hoisted_55 = { class: "fs-8 text-gray-700 mb-2 required" }
const _hoisted_56 = { class: "col-md-4 fv-row mb-3 pe-1" }
const _hoisted_57 = { class: "fs-8 text-gray-700 mb-2 required" }
const _hoisted_58 = { class: "col-md-4 fv-row mb-3 pe-1" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "fs-8 text-gray-700 mb-2 required" }, "شغل", -1)
const _hoisted_60 = { class: "col-md-4 fv-row mb-3 pe-1" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "fs-8 text-gray-700 mb-2 required" }, "سابقه فروش (سال)", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", null, "سال", -1)
const _hoisted_63 = { class: "col-md-4 fv-row mb-3 pe-1" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "fs-8 text-gray-700 mb-2" }, "تلفن ثابت", -1)
const _hoisted_65 = { class: "col-md-12 fv-row mb-3 pe-1" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "fs-8 text-gray-700 mb-2" }, "توضیحات", -1)
const _hoisted_67 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Desc = _resolveComponent("Desc")!
  const _component_Subset = _resolveComponent("Subset")!
  const _component_Credit = _resolveComponent("Credit")!
  const _component_PaymentRequestList = _resolveComponent("PaymentRequestList")!
  const _component_Details = _resolveComponent("Details")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "col-12 col-md-6",
          style: {"border-radius":"25px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("strong", null, _toDisplayString(_ctx.user.subusers_total_payments), 1),
              _hoisted_6
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          class: "col-12 col-md-6",
          style: {"border-radius":"25px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("strong", null, _toDisplayString(_ctx.user.total_commissions), 1),
              _hoisted_9
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          class: "col-12 col-md-6",
          style: {"border-radius":"25px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("strong", null, _toDisplayString(_ctx.user.subusers_count), 1),
              _hoisted_12
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          class: "col-12 col-md-6",
          style: {"border-radius":"25px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("strong", null, _toDisplayString(_ctx.user.subusers_buy_count), 1),
              _hoisted_15
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Desc),
      _createVNode(_component_Subset),
      _createVNode(_component_Credit),
      _createVNode(_component_PaymentRequestList)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_el_card, { style: {"border-radius":"25px"} }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }),
      _createVNode(_component_Details)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.status_modal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status_modal) = $event)),
      "before-close": _ctx.handleClose,
      "custom-class": "w-100 w-md-50"
    }, {
      default: _withCtx(() => [
        (_ctx.user.cooperation_status === 'not_requested')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("p", null, _toDisplayString(_ctx.user.first_name +' '+ _ctx.user.last_name) + " عزیز", 1),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_collapse, { class: "border-0 fs-7 border-dashed" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse_item, {
                      class: "border-0 fs-7 border-dashed",
                      name: "2"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_26
                      ]),
                      default: _withCtx(() => [
                        _hoisted_27,
                        _hoisted_28,
                        _hoisted_29,
                        _hoisted_30,
                        _hoisted_31,
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["d-flex cursor-pointer btn btn-outline btn-outline-dashed p-2 mt-6 border-success", 
        _ctx.rules_accept === true
                        ? 'border-success bg-light-success text-success'
                        : ''
                    ])
              }, [
                _createElementVNode("span", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rules_accept) = $event)),
                    value: "1"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rules_accept]
                  ]),
                  _hoisted_34
                ])
              ], 2),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "btn btn-primary mt-10 me-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.req_form = true)),
                  disabled: !_ctx.rules_accept
                }, "ثبت درخواست", 8, _hoisted_36),
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "btn btn-primary me-1 mt-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.user.cooperation_status === 'pending')
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(_component_center, null, {
                default: _withCtx(() => [
                  _hoisted_39,
                  _hoisted_40,
                  _createVNode(_component_router_link, {
                    to: "/dashboard",
                    class: "btn btn-sm btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.user.cooperation_status === 'rejected')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createVNode(_component_center, null, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _createElementVNode("p", null, _toDisplayString(_ctx.user.cooperation_reject_reason), 1),
                  _createVNode(_component_router_link, {
                    to: "/dashboard",
                    class: "btn btn-sm btn-primary me-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.req_form= true)),
                    class: "btn btn-sm btn-primary me-1"
                  }, "درخواست مجدد")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.req_form,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.req_form) = $event)),
      "custom-class": "w-100 w-md-50"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, [
                    _hoisted_51,
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      type: "radio",
                      name: "type",
                      value: "company",
                      modelValue: _ctx.req.type,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.req.type) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("label", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      type: "radio",
                      name: "type",
                      value: "regular",
                      modelValue: _ctx.req.type,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.req.type) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.req.type === 'company' ? 'نام شرکت': ' نام و نام خانوادگی'), 1),
                _createVNode(_component_el_input, {
                  size: "small",
                  modelValue: _ctx.req.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.req.name) = $event)),
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.req.type === 'company' ? 'شماره موبایل نماینده': 'شماره موبایل '), 1),
                _createVNode(_component_el_input, {
                  size: "small",
                  modelValue: _ctx.req.mobile,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.req.mobile) = $event)),
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createVNode(_component_el_input, {
                  size: "small",
                  modelValue: _ctx.req.job,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.req.job) = $event)),
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input_number, {
                    style: {"width":"100%"},
                    size: "small",
                    modelValue: _ctx.req.sales_history,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.req.sales_history) = $event)),
                    min: 0,
                    max: 50
                  }, {
                    suffix: _withCtx(() => [
                      _hoisted_62
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode(_component_el_input, {
                  size: "small",
                  modelValue: _ctx.req.phone,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.req.phone) = $event)),
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode(_component_el_input, {
                  rows: 2,
                  type: "textarea",
                  size: "small",
                  modelValue: _ctx.req.description,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.req.description) = $event)),
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("button", {
                class: "btn btn-primary mt-10",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.send_info()))
              }, "ارسال اطلاعات")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}